import { mapGetters } from 'vuex';
import _ from 'lodash';
import { InteractEventBus, Vue2InteractDraggable } from '../../../packages/vue2-interact/src';

const EVENTS = {
  MEDIA: 'MEDIA',
  SKIP: 'SKIP',
  JOKER: 'JOKER',
  LOVE: 'LOVE',
  CARD: 'CARD',
  LIKE: 'LIKE',
};
export default {
  name: 'MatchGameComponent',
  components: {},
  props: [],
  provide() {
    return {
      addElement: this.addElement,
    };
  },
  data() {
    return {
      profiles: [],
      errorReason: null,
      isVisible: true,
      inProgress: false,
      simpleLike: false,
      message: null,
      sequence: 0,
      interactEventBus: {
        draggedLeft: EVENTS.SKIP,
        draggedUp: EVENTS.JOKER,
        draggedRight: EVENTS.LOVE,
      },
      profileBuffer: 1,
      page: 0,
      joker: {
        count: 2,
        buyAsk: true,
      },
      proposalStaticCount: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    showButtons() {
      if (this.profilesCount === 0) {
        return false;
      }

      if (this.message && this.message.visible === true) {
        return false;
      }

      if (!this.$store.getters['matchGame/getShowButtons']) {
        return false;
      }
      return true;
    },
    showDetails() {
      return this.$store.getters['matchGame/getShowProfileDetails'];
    },
    interactDraggableStyle() {
      if (!this.showButtons) {
        return {};
      }
      return { 'touch-action': 'none' };
    },
    profilesCount() {
      return this.profiles.length;
    },
    current() {
      if (this.profiles.length > 0) {
        let profile = this.profiles[0];
        return {
          swipeable: true,
          type: 'USER',
          profile: profile,
        };
      }

      return {
        swipeable: false,
        type: this.errorReason,
      };
    },
    next() {
      if (this.profiles.length > 1) {
        let profile = this.profiles[1];
        return {
          swipeable: false,
          type: 'USER',
          profile: profile,
        };
      }
      // if (this.profiles.length === 1) {
      //     return {
      //         swipeable: false,
      //         type: 'NO_MORE',
      //     };
      // }
    },
  },
  watch: {
    profilesCount: function (newVal) {
      if (newVal < this.profileBuffer) {
        this.load();
      }
    },
    user: function (newVal, oldVal) {
      if (oldVal === null) {
        this.showMediaCard();
        this.setGameType();
      }
    },
    simpleLike: function (newVal, oldVal) {
      if (!newVal && !this.user.flags.MATCH_GAME_SWITCH) {
        this.setUserFlag();
      }

      if (this.user)
        window.localStorage.setItem('match-game-type' + this.user.id, newVal);
    },
  },
  methods: {
    load() {
      return axios
        .get(zRoute('ajax.match_game.index', { page: ++this.page }))
        .then(response => {
          if (response.data.data.length === 0) {
            this.errorReason = 'NO_MORE';
          } else {
            this.errorReason = null;
            if (this.profiles.length === 0) {
              this.profiles = response.data.data;
            } else {
              let newData = response.data.data.filter((profile) => {
                for (let j = 0; j < this.profiles.length; ++j) {
                  if (profile.id === this.profiles[j].id) {
                    return false;
                  }
                }
                return true;
              });

              this.profiles = this.profiles.concat(newData);
            }
          }
          this.profileBuffer = response.data.buffer ? response.data.buffer : 1;
        })
        .catch(error => {
          const data = error.response.data;
          this.handleErrorReason(data.reason);
          this.responseMessage = data.message;
        });
    },
    handleErrorReason(reason) {
      this.errorReason = null;

      if (reason === this.globals.actions.ACTION_NOT_ENOUGH_MATCHES) {
        this.errorReason = 'NO_MORE_MATCHES';
        return;
      }
      if (reason === this.globals.actions.ACTION_NOT_ENOUGH_COINS) {
        this.$eventHub.$emit('EventPopupModalOpen', this.globals.actions.ACTION_NOT_ENOUGH_COINS);
        return;
      }
      if (reason === this.globals.actions.ACTION_MG_NO_AVATAR) {
        this.setMessage(EVENTS.MEDIA);
        return;
      }
      if (reason === this.globals.actions.ACTION_MG_DAILY_LIMIT) {
        this.errorReason = 'DAILY_LIMIT_REACHED';
        return;
      }
      console.log('Unknown reason: ' + reason);
    },
    setUserFlag: _.throttle(() => {
      axios.put(zRoute('ajax.user.flags.update', 'MATCH_GAME_SWITCH'));
    }, 20000),
    skipBtn() {
      if (!this.inProgress)
        InteractEventBus.$emit(EVENTS.SKIP);
    },
    jokerBtn() {
      if (!this.inProgress)
        this.emitAndNext('JOKER');
      // InteractEventBus.$emit(EVENTS.JOKER)
    },
    loveBtn() {
      if (!this.inProgress)
        InteractEventBus.$emit(EVENTS.LOVE);
      // this.emitAndNext('LOVE');
    },
    actionCard(event) {
      if (event === 'NEXT') {
        // this.showButtons = true;
        this.skipAction({ name: event });
      }
    },
    closeCard() {
      this.message = null;
    },
    emitAndNext(event) {
      if (event === EVENTS.JOKER) {
        this.jokerAction({ name: event });
      } else if (event === EVENTS.LOVE) {
        this.loveAction({ name: event });
      } else {
        this.skipAction({ name: event });
      }

      return true;
    },
    skipAction(event) {
      if (this.inProgress) {
        return false;
      }
      this.inProgress = true;

      axios
        .post(zRoute('ajax.match_game.skip', this.current.profile.id), {
          event: event,
          current: this.current,
          sequence: this.sequence,
          start: !this.next,
        })
        .finally(() => {
          this.isVisible = false;
          this.$nextTick(() => {
            this.nextAction();
            this.isVisible = true;
            this.inProgress = false;
          });
        });
    },
    nextAction() {
      this.$store.dispatch('matchGame/reset');
      this.profiles.splice(0, 1);

      this.isVisible = false;
      this.$nextTick(() => {
        this.isVisible = true;
      });
    },
    jokerAction(event) {
      if ((this.user.free_jokers + this.user.jokers) > 0) {
        return axios
          .post(zRoute('ajax.match_game.joker', this.current.profile.id))
          .then(response => {
            if (response.data.status === 'success') {
              this.setMessage(EVENTS.JOKER);
              //  this.showStep = this.steps.MESSAGE;
              //    this.$store.dispatch('profiles/loadMatches');
            }
            this.responseMessage = response.data.message;
          })
          .catch(error => {
            const data = error.response.data;
            this.responseMessage = data.message;
          });
      }
      this.$router.push({ name: 'payment', params: { unit: 'jokers' } });
      // window.location.href = zRoute('front.more_settings.payment', 'jokers');
    },
    loveAction(event) {
      if (this.simpleLike) {
        this.sendLike();
      } else {
        this.setMessage(EVENTS.LOVE);
      }
    },
    sendLike() {
      return axios
        .post(zRoute('ajax.match_game.like'), {
          profile_id: this.current.profile.id,
        })
        .then(response => {
          if (response.data.status === 'success') {
            if (response.data.data.matched === true) {
              this.setMessage(EVENTS.LIKE);
            } else {
              this.nextAction();
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    setMessage(type) {
      this.message = {
        type: type,
        visible: true,
      };

      /**
       * Reset Vue2InteractDraggable to current
       */
      this.isVisible = false;
      this.$nextTick(() => {
        this.isVisible = true;
      });
    },
    hideDetails() {
      this.$store.dispatch('matchGame/showButtons', true);
      this.$store.dispatch('matchGame/showProfileDetails', false);
    },
    showMediaCard() {
      let user = this.user;
      if (window.appVersionCode >= 108) {
        return;
      }

      if (user) {
        if (user.has_avatar) {
          return;
        }
        axios
          .get(zRoute('ajax.user.media.index', { public: true, free: true }))
          .then(response => {
            if (response.data.data.length === 0) {
              this.setMessage(EVENTS.MEDIA);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    setGameType() {
      let user = this.user;

      if (user) {
        const matchGameType = window.localStorage.getItem('match-game-type' + user.id);

        if (matchGameType !== null) {
          this.simpleLike = matchGameType === 'true' || matchGameType === true;
        }
      }
    },
  },
  mounted() {
    this.load();
    this.showMediaCard();
    this.setGameType();

    document.body.style.overflowX = 'hidden';
    this.$store.dispatch('homeProfiles/load');
  }
};
